import * as angular from 'angular';

import { stateForSinglePolicyPage } from 'states/utilities';

import * as checklistPage from 'pages/checklist';
import * as claimsPage from 'pages/claims';
import * as coveragePage from 'pages/coverage';
import * as getMorePage from 'pages/get-more';
import * as messagesPage from 'pages/messages';
import * as overviewPage from 'pages/overview';
import * as paymentsPage from 'pages/payments';

import * as customerPortalPages from 'pages';

// this one is different because it is for multiple policies, not a single policy
import * as loginState from 'states/login';
import * as logoutState from 'common/source/states/logout';
import * as policiesState from 'states/policies';
import * as errorState from 'states/error';

export const states = {
    checklist: stateForSinglePolicyPage(checklistPage),
    claims: stateForSinglePolicyPage(claimsPage),
    coverage: stateForSinglePolicyPage(coveragePage),
    error: errorState,
    getMore: stateForSinglePolicyPage(getMorePage),
    login: loginState,
    logout: logoutState,
    messages: stateForSinglePolicyPage(messagesPage),
    overview: stateForSinglePolicyPage(overviewPage),
    payments: stateForSinglePolicyPage(paymentsPage),
    policies: policiesState
};

export const module = angular.module('customerPortalStates', [customerPortalPages.module.name]);
